import { render, staticRenderFns } from "./IoTMonitorModule.vue?vue&type=template&id=4dc43cf2&scoped=true"
import script from "./IoTMonitorModule.vue?vue&type=script&lang=js"
export * from "./IoTMonitorModule.vue?vue&type=script&lang=js"
import style0 from "./IoTMonitorModule.vue?vue&type=style&index=0&id=4dc43cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc43cf2",
  null
  
)

export default component.exports